import { format, parseISO } from 'date-fns';

/** Format an ISO timestamp as "MMM d" — e.g. "Apr 9". */
export function formatShortDate(iso: string): string {
  try {
    return format(parseISO(iso), 'MMM d');
  } catch {
    return iso;
  }
}

/** Format an "YYYY-MM-DD" string as "MMM d". */
export function formatShortDay(date: string): string {
  try {
    return format(parseISO(date), 'MMM d');
  } catch {
    return date;
  }
}

/** Format a rate in [0,1] as percentage with no decimals. */
export function formatPercentRate(rate: number): string {
  if (!Number.isFinite(rate)) return '—';
  return `${Math.round(rate * 100)}%`;
}

/** Format cents as "$X.XX". */
export function formatCents(cents: number): string {
  if (!Number.isFinite(cents)) return '—';
  return `$${(cents / 100).toFixed(2)}`;
}
